import { ptBR as userGroupsTranslations } from '../UserGroup/pt-BR';
import type { IGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const ptBR: IGroupsTranslations = {
  route: 'Grupos',
  chooseGroup: {
    title: 'Criar grupos',
    description: 'Selecione o tipo de grupo que deseja criar.',
    cards: {
      devices: {
        title: 'Dispositivos',
        description:
          'Crie grupos de dispositivos para ajudar a segmentar ou categorizar conforme suas necessidades.',
      },
      users: {
        title: 'Usuários',
        description:
          'Crie grupos de usuários para segmentar quais usuários poderão ver determinados dispositivos.',
      },
    },
  },
  modals: {
    newGroupAssignment: {
      title: 'Deseja atribuir a um novo grupo de usuários?',
      description: 'Você será direcionado ao processo de criação de um novo grupo.',
      cancelButton: 'Não',
      confirmButton: 'Sim',
    },
    deviceGroupLink: {
      title: 'Atenção!',
      description:
        'Para garantir o bom funcionamento deste novo grupo, é importante vinculá-lo a um grupo de dispositivos. Deseja fazer essa associação agora?',
      cancelButton: 'Não',
      confirmButton: 'Sim',
    },
    redirecting: {
      title: 'Você está sendo redirecionado para a tela de criação de grupos',
      description:
        'Não se preocupe, as configurações já definidas estão salvas e você poderá revisá-las mais tarde antes de finalizar a criação do grupo.',
    },
  },
  overview: {
    title: 'Resumo de grupos',
    description: 'Verifique os parâmetros escolhidos para os grupos.',
    groupData: {
      title: 'Dados do grupo',
      groupName: 'Nome do grupo',
      groupDescription: 'Descrição',
    },
    hierarchy: {
      title: 'Hierarquia',
      belongsTo: 'Pertencerá ao grupo:',
    },
    permissions: {
      title: 'Permissões de grupos',
      administrators: 'Administradores',
      viewers: 'Perfis somente leitura',
    },
    devicesCount: {
      title: 'Dispositivos',
    },
    assignedGroups: {
      assignOne: {
        title: 'Grupo atribuído 1',
      },
      assignTwo: {
        title: 'Grupo atribuído 2',
      },
      groupName: 'Nome do grupo',
      description: 'Descrição',
      users: 'Usuários',
      user: 'usuário',
      permissions: {
        label: 'Permissões de grupos',
        administrators: 'Administradores:',
        viewers: 'Perfis somente leitura:',
      },
    },
    submitButton: 'Feito',
  },
  userGroups: userGroupsTranslations,
};

export { ptBR };
